import AnimateHeight from 'react-animate-height';
import { t } from 'ttag';
import { ReactComponent as IconStar } from 'static/Common/icon-star.svg';
import { ReactComponent as IconMail } from 'static/Common/icon-mail.svg';
import { ReactComponent as IconPhone } from 'static/Common/icon-phone.svg';
import { ReactComponent as IconCheck } from 'static/Common/icon-check.svg';
import { ReactComponent as IconXmark } from 'static/Common/icon-xmark.svg';
import { ReactComponent as IconBuilding } from 'static/Common/icon-building.svg';
import { ReactComponent as IconLocationDot } from 'static/Common/icon-location-dot.svg';
import OpeningHours from 'components/OpeningHours/index.js';
import { SiteListContext } from '..';
import './index.scss';

const SiteListItem = ({ site, isExpanded, onClick, onMouseEnter, onMouseLeave, headerChildren, children }) => {
    const { isNearest, name, company, location, email, phone, has_pickup, id } = site;
    const { address = '', city = '', lat, lng } = location || {};

    const hasPin = lat && lng;

    return (
        <li
            className={`site-list-item ${isNearest ? 'nearest' : ''} ${isExpanded ? 'expanded' : ''}`}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <button type='button' onClick={() => onClick(id)} className='list-item-toggle'>
                <h3>{name}</h3>
                {headerChildren && (
                    <SiteListContext.Provider value={site}>
                        {headerChildren}
                    </SiteListContext.Provider>
                )}
                {isNearest && <IconStar />}
                {!hasPin && (
                    <div className='no-pin-icon-wrap' title={t`(ELV_STATION_LIST_MAP)_SITE_HAS_NO_LOCATION_TOOLTIP`}>
                        <IconLocationDot />
                        <IconXmark />
                    </div>
                )}
            </button>
            <AnimateHeight animateOpacity duration={200} height={isExpanded ? 'auto' : 0}>
                <div className='list-item-body'>
                    <span className='site-info site-info-name'>
                        <IconBuilding />
                        {company?.name || '-'}
                    </span>
                    <span className='site-info'>
                        <IconLocationDot />
                        {[address, city].filter(v => v).join(', ') || '-'}
                    </span>
                    {email && (
                        <a href={`mailto:${email}`} className='site-info'>
                            <IconMail />
                            {email}
                        </a>
                    )}
                    {phone && (
                        <a href={`tel:${phone}`} className='site-info'>
                            <IconPhone />
                            {phone}
                        </a>
                    )}
                    <OpeningHours shop={site} />
                    <span className='site-info site-info-pickup'>
                        {has_pickup ? (
                            <>
                                <IconCheck />
                                {t`(ELV_STATION_LIST_MAP)_SITE_PICKUP_AVAILABLE`}
                            </>
                        ) : (
                            <>
                                <IconXmark />
                                {t`(ELV_STATION_LIST_MAP)_SITE_PICKUP_UNAVAILABLE`}
                            </>
                        )}
                    </span>
                    {children && (
                        <SiteListContext.Provider value={site}>
                            {children}
                        </SiteListContext.Provider>
                    )}
                </div>
            </AnimateHeight>
        </li>
    );
};

export default SiteListItem;
